// noinspection ExceptionCaughtLocallyJS

import * as constants from '../constants';
import { setLoading, wrap, wrapAndThrowError } from './index';
import { Dispatch } from 'redux';
import {
  SchemaGetBookBastetQueryParams,
  SchemaGetPaymentMethodsQueryParams,
  SchemaPostAddVoucherRequestBody,
  SchemaPostCustomerDataRequestBody,
  SchemaPostDeleteVoucherRequestBody,
  SchemaPostReserveBasketRequestBody,
  SchemaPostStartPaymentProcessRequestBody,
  SchemaPostStopPaymentProcessRequestBody,
} from '@repo/legacy-commerce-api';
import legacyApi from '../middlewares/api';

// API Unused, leave as it's legacy:
export const postBasketCustomer = (payload: any) =>
  wrap(async (dispatch: Dispatch) => {
    try {
      if (payload.basketreference === null) {
        delete payload.basketreference;
      }
      dispatch(setLoading(true));

      const { data, error } = await legacyApi.POST('/basketcustomer', { body: payload as never });

      if (error) {
        throw JSON.stringify(error);
      }

      dispatch(setLoading(false));
      dispatch({
        type: constants.BASKET_CUSTOMER_POSTED,
        // @ts-expect-error response is not typed:
        payload: { ...data, basket: payload.basket },
      });
      return data;
    } catch (err) {
      console.error('error: ', err);
      dispatch(setLoading(false));
      throw err;
    }
  }, 'POST_ERROR');

export const postCustomerData = (payload: SchemaPostCustomerDataRequestBody) =>
  wrap(async (dispatch: Dispatch) => {
    try {
      dispatch(setLoading(true));
      const { data, error } = await legacyApi.POST('/customerdata', { body: payload });

      if (error) {
        throw JSON.stringify(error);
      }

      dispatch({
        type: constants.BASKET_CUSTOMER_POSTED,
        payload: { ...data, basket: payload.basket },
      });

      return data;
    } catch (err) {
      console.error('error: ', err);
      throw err;
    } finally {
      dispatch(setLoading(false));
    }
  }, constants.POST_ERROR);

export const getBookBasket = (params: SchemaGetBookBastetQueryParams) =>
  wrapAndThrowError(async (dispatch: Dispatch) => {
    try {
      dispatch(setLoading(true));
      const { data, error } = await legacyApi.GET('/bookbasket', { params: { query: params } });

      if (error) {
        throw JSON.stringify(error);
      }

      dispatch({ type: constants.BOOKED_BASKET, payload: { ...data } });
      return data;
    } catch (err) {
      console.log('error: ', err);
      dispatch(setLoading(false));
      throw err;
    } finally {
      dispatch(setLoading(false));
    }
  }, 'POST_ERROR');

export const postAddVoucher = (payload: SchemaPostAddVoucherRequestBody) =>
  wrap(async (dispatch: Dispatch) => {
    try {
      dispatch(setLoading({ value: true, name: 'voucher' }));
      const { data, error } = await legacyApi.POST('/addvoucher', { body: payload });

      if (error) {
        throw JSON.stringify(error);
      }

      return data;
    } catch (err) {
      console.error('error: ', err);
      dispatch(setLoading({ value: false, name: 'voucher' }));
      throw err;
    } finally {
      dispatch(setLoading({ value: false, name: 'voucher' }));
    }
  }, 'POST_ERROR');

export const postDeleteVoucher = (payload: SchemaPostDeleteVoucherRequestBody) =>
  wrap(async (dispatch: Dispatch) => {
    try {
      dispatch(setLoading({ value: true, name: 'voucher' }));
      const { data, error } = await legacyApi.POST('/deletevoucher', { body: payload });

      if (error) {
        throw JSON.stringify(error);
      }

      dispatch({ type: constants.DELETED_VOUCHER, payload: { ...data } });
      return data;
    } catch (err) {
      console.error('error: ', err);
      dispatch(setLoading({ value: false, name: 'voucher' }));
      throw err;
    } finally {
      dispatch(setLoading({ value: false, name: 'voucher' }));
    }
  }, 'POST_ERROR');

export const fetchPaymentMethods = (params: SchemaGetPaymentMethodsQueryParams) =>
  wrap(async (dispatch: Dispatch) => {
    try {
      dispatch(setLoading(true));
      const { data, error } = await legacyApi.GET('/paymentmethods', { params: { query: params } });

      if (error) {
        throw JSON.stringify(error);
      }

      dispatch({
        type: constants.FETCHED_PAYMENT_METHODS,
        payload: data,
      });

      return data.data;
    } catch (err) {
      console.error('error: ', err);
      dispatch(setLoading(false));
      throw err;
    } finally {
      dispatch(setLoading(false));
    }
  }, constants.FETCH_ERROR);

export const postReserveBasket = (payload: SchemaPostReserveBasketRequestBody) =>
  wrap(async (dispatch: Dispatch) => {
    try {
      dispatch(
        setLoading({
          value: true,
          name: 'basketReserving',
        }),
      );
      dispatch(setLoading(true));
      if (payload.basketreference === null) {
        delete payload.basketreference;
      }

      const { data, error } = await legacyApi.POST('/reservebasket', { body: payload });

      if (error) {
        throw JSON.stringify(error);
      }

      dispatch({ type: constants.RESERVED_BASKET, payload: { ...data } });
      dispatch(
        setLoading({
          value: false,
          name: 'basketReserving',
        }),
      );
      return data;
    } catch (err) {
      console.error('error: ', err);
      dispatch(
        setLoading({
          value: false,
          name: 'basketReserving',
        }),
      );
      throw err;
    }
  }, 'POST_ERROR');

export const startPaymentProcess = (payload: SchemaPostStartPaymentProcessRequestBody) =>
  wrap(async (dispatch: Dispatch) => {
    try {
      dispatch(setLoading(true));

      // @ts-expect-error basketreference does not exist on payload type:
      if (payload.basketreference === null) {
        // @ts-expect-error basketreference does not exist on payload type:
        delete payload.basketreference;
      }

      const { data, error } = await legacyApi.POST('/startpaymentprocess', { body: payload });

      if (error) {
        throw JSON.stringify(error);
      }

      dispatch({
        type: constants.STARTED_PAYMENT,
        payload: { ...payload },
      });
      return data;
    } catch (err) {
      console.error('error: ', err);
      dispatch(setLoading(false));
      throw err;
    } finally {
      dispatch(setLoading(false));
    }
  }, 'POST_ERROR');

export const stopPaymentProcess = (payload: SchemaPostStopPaymentProcessRequestBody) =>
  wrap(async (dispatch: Dispatch) => {
    try {
      dispatch(setLoading(true));

      // @ts-expect-error basketreference does not exist on payload type:
      if (payload.basketreference === null) {
        // @ts-expect-error basketreference does not exist on payload type:
        delete payload.basketreference;
      }

      const { data, error } = await legacyApi.POST('/stoppaymentprocess', { body: payload });

      if (error) {
        throw JSON.stringify(error);
      }

      dispatch({
        type: constants.STOPPED_PAYMENT,
        payload: { ...payload },
      });
      return data;
    } catch (err) {
      console.error('error: ', err);
      dispatch(setLoading(false));
      throw err;
    } finally {
      dispatch(setLoading(false));
    }
  }, 'POST_ERROR');

export const getPostfinanceAccept = (params: string) =>
  wrap(async (dispatch: Dispatch) => {
    try {
      dispatch(setLoading(true));

      // Legacy: parse everything we get and send it over:
      const queryObj = Object.fromEntries(new URLSearchParams(params));
      const { data, error } = await legacyApi.GET('/paymentaccept', { params: { query: queryObj as any } });

      if (error) {
        throw JSON.stringify(error);
      }

      dispatch({ type: constants.PAYMENT_EVENT, payload: { ...data } });
      return data;
    } catch (err) {
      console.error('error: ', err);
      dispatch(setLoading(false));
      throw err;
    } finally {
      dispatch(setLoading(false));
    }
  }, constants.FETCH_ERROR);

export const getPostfinanceCancel = (params: string) =>
  wrap(async (dispatch: Dispatch) => {
    try {
      dispatch(setLoading(true));

      // Legacy: parse everything we get and send it over:
      const queryObj = Object.fromEntries(new URLSearchParams(params));
      const { data, error } = await legacyApi.GET('/paymentcancel', { params: { query: queryObj as any } });

      if (error) {
        throw JSON.stringify(error);
      }

      dispatch({ type: constants.PAYMENT_EVENT, payload: { ...data } });
      return data;
    } catch (err) {
      console.error('error: ', err);
      dispatch(setLoading(false));
      throw err;
    } finally {
      dispatch(setLoading(false));
    }
  }, constants.FETCH_ERROR);

export const getPostfinanceDecline = (params: string) =>
  wrap(async (dispatch: Dispatch) => {
    try {
      dispatch(setLoading(true));

      // Legacy: parse everything we get and send it over:
      const queryObj = Object.fromEntries(new URLSearchParams(params));
      const { data, error } = await legacyApi.GET('/paymentdecline', { params: { query: queryObj as never } });

      if (error) {
        throw JSON.stringify(error);
      }

      // @ts-expect-error no response types defined:
      dispatch({ type: constants.PAYMENT_EVENT, payload: { ...data } });
      return data;
    } catch (err) {
      console.error('error: ', err);
      dispatch(setLoading(false));
      throw err;
    } finally {
      dispatch(setLoading(false));
    }
  }, constants.FETCH_ERROR);

export const getPostfinanceException = (params: string) =>
  wrap(async (dispatch: Dispatch) => {
    try {
      dispatch(setLoading(true));

      // Legacy: parse everything we get and send it over:
      const queryObj = Object.fromEntries(new URLSearchParams(params));
      const { data, error } = await legacyApi.GET('/paymentexception', { params: { query: queryObj as never } });

      if (error) {
        throw JSON.stringify(error);
      }

      // @ts-expect-error no response type defined here:
      dispatch({ type: constants.PAYMENT_EVENT, payload: { ...data } });
      return data;
    } catch (err) {
      console.error('error: ', err);
      dispatch(setLoading(false));
      throw err;
    } finally {
      dispatch(setLoading(false));
    }
  }, constants.FETCH_ERROR);

/**
 * No route found, leaving as legacy code:
 */
/* export const giveFeedback = (payload) =>
  wrap((dispatch: Dispatch) => {
    try {
      dispatch(setLoading(true));
      return apiCaller('POST', `orderfeedback`, payload).then((resData) => {
        dispatch(setLoading(false));
        dispatch({ type: constants.GAVE_FEEDBACK, payload: { ...payload } });
        return resData;
      });
    } catch (err) {
      console.error('error: ', err);
      dispatch(setLoading(false));
      throw err;
    }
  }, 'POST_ERROR'); */

export const setCampaignName = (payload: string) => ({
  type: constants.SET_CAMPAIGN_NAME,
  payload,
});

export const setIsBasketBooked = (payload: boolean) => ({
  type: constants.SET_IS_BASKET_BOOKED,
  payload,
});
